import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { BrandButton as Button } from "@/components";

export default function PortalButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/admin');
  };

  return (
    <Button
      onClick={handleClick}
      size="large"
      style={{ 
        fontSize: "1.7rem", 
        whiteSpace: "nowrap",
        minWidth: "fit-content"
      }}
    >
      Admin Portal
    </Button>
  );
}
